module.exports = __webpack_public_path__ + "static/media/step4.8c282ce2.png";